<template>
  <loading-container :loading="!formInited">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Install Instruction</h4>
      </div>
      <div class="card-body">
        <div class="mb-3">
          <div>
            <p>Step 1: Go to Shopify App Store</p>
            <p>Step 2: Install Printhigh POD Fulfillment to your store</p>
            <p><b>Step 3: Enter Printhigh Store Name below to connect with your shopify store</b></p>
            <p>Step 4: Create new products</p>
            <p>Step 5: Wait for new orders</p>
            <p>Step 6: Wait for us to do the rest</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Shopify Configuration</h4>
      </div>
      <div class="card-body">
        <input-text
          type="text"
          label="Name"
          placeholder="Name"
          :value="form.name"
          :required="true"
          :errors="error.name"
          @input="value => setField({ key: 'name', value })"
        />

        <div class="mt-3 text-right">
          <form-button
            type="primary"
            input-type="button"
            :disabled="formLoading"
            :loading="formLoading"
            text="SAVE"
            :click="() => createShopifyStore()"
          />
        </div>
      </div>
    </div>
  </loading-container>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

import InputText from "@/components/Form/InputText";
import FormButton from "@/components/Form/FormButton";
import AlertBox from '@/components/Misc/AlertBox';
import LoadingContainer from "@/components/Misc/LoadingContainer";

export default {
    name: "CreateShopifyStore",
    components: {
      InputText,
      FormButton,
      AlertBox,
      LoadingContainer,
    },
    beforeMount() {
      const query = this.$route.query;
      const hmac = query.hmac;
      const shop = query.shop;
      const code = query.code;
      const state = query.state;
      const timestamp = query.timestamp;
      this.setField({ key: 'type', value: 'shopify' });
      this.setField({ key: 'hmac', value: hmac });
      this.setField({ key: 'shop', value: shop });
      this.setField({ key: 'code', value: code });
      this.setField({ key: 'state', value: state });
      this.setField({ key: 'timestamp', value: timestamp });
      this.checkShopifyStore();
    },
    computed: {
      ...mapGetters({
        formInited: "store/formInited",
        formLoading: "store/formLoading",
        form: "store/form",
        error: 'store/error',
      }),
      loadingX() {
        return this.loading;
      },
    },
    methods: {
      ...mapActions({
        setField: "store/setField",
        createShopifyStore: "store/createShopifyStore",
        checkShopifyStore: "store/checkShopifyStore",
      }),
    }
  };
</script>
